export default __webpack_public_path__ + "static/media/2458.774d9c27.png";